import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import times from 'lodash/times';
import { v4 as uuid } from 'uuid';

class LevelIndicator extends PureComponent {
  generateIcon = (index, level) => (
    <i
      className={`icon-${index <= level ? this.props.completeIcon : this.props.incompleteIcon}
        ${index <= level ? this.props.completeColor : this.props.incompleteColor}`}
      style={{ paddingRight: '2px' }}
      key={uuid()}
    />
  );

  render() {
    return (
      <div className={`level-indicator di ${this.props.levelFontSize}`}>
        {times(this.props.maxLevel).map(index =>
          this.generateIcon(index + 1, this.props.currentLevel),
        )}
      </div>
    );
  }
}

LevelIndicator.propTypes = {
  completeColor: PropTypes.string,
  completeIcon: PropTypes.string,
  incompleteColor: PropTypes.string,
  incompleteIcon: PropTypes.string,
  currentLevel: PropTypes.string,
  maxLevel: PropTypes.number,
  levelFontSize: PropTypes.string,
};

LevelIndicator.defaultProps = {
  completeColor: 'red',
  completeIcon: 'pick',
  incompleteColor: 'moon-gray',
  incompleteIcon: 'pick',
  currentLevel: 0,
  maxLevel: 3,
  levelFontSize: '',
};

export default LevelIndicator;
